import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Cart from "../../network/api/cart";
import { useTranslation } from "react-i18next";

const ProductInCart = (props) => {
  const navigate = useNavigate();
  const [active, setactive] = useState(true);
  const [Error, setError] = useState("");
  const { t, i18n } = useTranslation();
  const totalDiscountToday = (props?.product?.todayDiscount || []).reduce(
    (sum, m) => sum + m.discount,
    0
  );
  const totalDiscountFlash = (props?.product?.flashDiscount || []).reduce(
    (sum, m) => sum + m.discount,
    0
  );

  return (
    <div className="product-in-cart mb-2" key={props.key}>
      <div className="d-flex gap-3">
        <img src={`${props?.product?.images[0]?.secure_url}`} alt="product" />
        <div className="">
          <h4
            onClick={() => {
              window.scrollTo(0, 0);
              navigate(`/productdetails/${props?.product?._id}`);
            }}
          >
           {i18n.language == "en" ? props?.product?.name : props?.product?.name_ar}
          </h4>

          <div className="price">
            <span>{t("curency")}</span>{" "}
            {props.product?.price_after * props.cart?.quantity - totalDiscountToday * props.cart?.quantity - totalDiscountFlash * props.cart?.quantity}
          </div>
          <div className="size-clr d-flex gap-3">
            <div className="size">
              <span>{t("size")}:</span> {props.cart?.size}
            </div>
            <div className="clr d-flex gap-3 align-items-center">
              <span>{t("color")}:</span>{" "}
              <div
                style={{
                  backgroundColor: props.cart?.color,
                  width: "50px",
                  height: "20px",
                }}
              ></div>
            </div>
          </div>
          <div className="qun d-flex align-items-center ">
            <button
              className="add"
              onClick={async () => {
                // if (
                //   props?.cart?.quantity !==
                //   parseInt(props?.product?.quantity[props?.cart?.size])
                // ) {
           
                  setactive(false);
                  if (active)
                    Cart?.increse_item(props?.cart?._id).then(async (e) => {
                      await props.load();
                      setactive(true);
                    });
                // } else {
                //   setError("product reached to maximum quantity");
                //   setTimeout(() => {
                //     setError("");
                //   }, 1000);
                // }
              }}
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.80177 12V0H7.18935V12H4.80177ZM0 7.18935V4.80178H12V7.18935H0Z"
                  fill="white"
                />
              </svg>
            </button>
            <input type="num" value={props?.cart?.quantity} />
            <button
              className="muns"
              onClick={async () => {
                if (props.cart?.quantity <= 1) {
                  setError("can't be less than one");
                  setTimeout(() => {
                    setError("");
                  }, 1000);
                }
                if (props.cart?.quantity !== 0) {
                  setactive(false);
                  if (active)
                    Cart.decrease_item(props.cart?._id).then(async (e) => {
                      await props.load();
                      setactive(true);
                    });
                }
              }}
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 5V7H0V5H12Z" fill="#C9CCCF" />
              </svg>
            </button>
          </div>
          {/* <button className='wish-addtocart-btn add-cart rounded-2 mt-3' style={{background:'#C99700'}}
            onClick={() => navigate(`/productdetails/${props.product?._id}`)}>
            نقل الي عربة التسوق</button> */}
        </div>
      </div>
      <button
        className="delete"
        onClick={() => {
          Cart.Delete_cart_item(props.cart?._id).then((e) => {
            props.load();
          });
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.0036 6.72998C20.9836 6.72998 20.9536 6.72998 20.9236 6.72998C15.6336 6.19998 10.3536 5.99998 5.12358 6.52998L3.08358 6.72998C2.66358 6.76998 2.29358 6.46998 2.25358 6.04998C2.21358 5.62998 2.51358 5.26998 2.92358 5.22998L4.96358 5.02998C10.2836 4.48998 15.6736 4.69998 21.0736 5.22998C21.4836 5.26998 21.7836 5.63998 21.7436 6.04998C21.7136 6.43998 21.3836 6.72998 21.0036 6.72998Z"
            fill="#C8C8C8"
          />
          <path
            d="M8.50074 5.72C8.46074 5.72 8.42074 5.72 8.37074 5.71C7.97074 5.64 7.69074 5.25 7.76074 4.85L7.98074 3.54C8.14074 2.58 8.36074 1.25 10.6907 1.25H13.3107C15.6507 1.25 15.8707 2.63 16.0207 3.55L16.2407 4.85C16.3107 5.26 16.0307 5.65 15.6307 5.71C15.2207 5.78 14.8307 5.5 14.7707 5.1L14.5507 3.8C14.4107 2.93 14.3807 2.76 13.3207 2.76H10.7007C9.64074 2.76 9.62074 2.9 9.47074 3.79L9.24074 5.09C9.18074 5.46 8.86074 5.72 8.50074 5.72Z"
            fill="#C8C8C8"
          />
          <path
            d="M15.2104 22.7501H8.79039C5.30039 22.7501 5.16039 20.8201 5.05039 19.2601L4.40039 9.19007C4.37039 8.78007 4.69039 8.42008 5.10039 8.39008C5.52039 8.37008 5.87039 8.68008 5.90039 9.09008L6.55039 19.1601C6.66039 20.6801 6.70039 21.2501 8.79039 21.2501H15.2104C17.3104 21.2501 17.3504 20.6801 17.4504 19.1601L18.1004 9.09008C18.1304 8.68008 18.4904 8.37008 18.9004 8.39008C19.3104 8.42008 19.6304 8.77007 19.6004 9.19007L18.9504 19.2601C18.8404 20.8201 18.7004 22.7501 15.2104 22.7501Z"
            fill="#C8C8C8"
          />
          <path
            d="M13.6581 17.25H10.3281C9.91813 17.25 9.57812 16.91 9.57812 16.5C9.57812 16.09 9.91813 15.75 10.3281 15.75H13.6581C14.0681 15.75 14.4081 16.09 14.4081 16.5C14.4081 16.91 14.0681 17.25 13.6581 17.25Z"
            fill="#C8C8C8"
          />
          <path
            d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
            fill="#C8C8C8"
          />
        </svg>
      </button>
    </div>
  );
};

export default ProductInCart;
